import { pendingResultFromHistory, type GameResultsOutbox } from './gameResults'
import type { UserProfile } from './userModel'

export function normalizeGameResultsOutbox(
  raw: unknown,
  legacyUser?: UserProfile | null,
  recoverMetrics = false,
): GameResultsOutbox {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    if (!legacyUser) return {}
    return {
      [legacyUser.id]: (legacyUser.history ?? [])
        .flatMap((entry) => {
          const result = pendingResultFromHistory(entry, true)
          return result ? [result] : []
        })
        .reverse(),
    }
  }
  const outbox: GameResultsOutbox = {}
  for (const [userId, entries] of Object.entries(raw)) {
    if (!Array.isArray(entries)) continue
    outbox[userId] = entries.filter(
      (entry) =>
        entry &&
        typeof entry.id === 'string' &&
        entry.id.length > 0 &&
        entry.id.length <= 128 &&
        (entry.kind === 'strategy' || entry.kind === 'puzzle') &&
        typeof entry.vsAI === 'boolean' &&
        ['win', 'loss', 'draw'].includes(entry.result) &&
        Number.isSafeInteger(entry.ts) &&
        entry.ts >= 0,
    )
  }
  if (recoverMetrics && legacyUser) {
    const pending = new Map(
      (outbox[legacyUser.id] ?? []).map((result) => [result.id, result]),
    )
    for (const entry of [...(legacyUser.history ?? [])].reverse()) {
      const recovered = pendingResultFromHistory(entry, true)
      if (recovered?.durationMs == null) continue
      const existing = pending.get(entry.id)
      pending.set(entry.id, {
        ...recovered,
        ...existing,
        scoreDiff: recovered.scoreDiff,
        durationMs: recovered.durationMs,
        statsRecorded: existing?.statsRecorded ?? !existing,
      })
    }
    outbox[legacyUser.id] = [...pending.values()]
  }
  return outbox
}
